// =============================================================================
// Wiki Store - Zustand store for wiki module
// =============================================================================

import { create } from 'zustand';
import type { DocDocument } from '../types';
import { fetchWikiDocuments, convertToWiki, convertFromWiki, searchWikiPages } from '../data/wikiRepository';

interface WikiState {
  wikiDocs: DocDocument[];
  loadingWiki: boolean;
  searchResults: any[];
  searchLoading: boolean;

  loadWikiDocs: (orgId: string) => Promise<void>;
  convertDocToWiki: (docId: string, updatedBy: string, orgId: string) => Promise<void>;
  convertDocFromWiki: (docId: string, updatedBy: string, orgId: string) => Promise<void>;
  searchWiki: (orgId: string, query: string) => Promise<void>;
  clearSearch: () => void;
}

export const useWikiStore = create<WikiState>((set, get) => ({
  wikiDocs: [],
  loadingWiki: false,
  searchResults: [],
  searchLoading: false,

  loadWikiDocs: async (orgId) => {
    set({ loadingWiki: true });
    try {
      const docs = await fetchWikiDocuments(orgId);
      set({ wikiDocs: docs, loadingWiki: false });
    } catch (err) {
      console.error('Error loading wiki docs:', err);
      set({ loadingWiki: false });
    }
  },

  convertDocToWiki: async (docId, updatedBy, orgId) => {
    await convertToWiki(docId, updatedBy);
    await get().loadWikiDocs(orgId);
  },

  convertDocFromWiki: async (docId, updatedBy, orgId) => {
    await convertFromWiki(docId, updatedBy);
    set(s => ({ wikiDocs: s.wikiDocs.filter(d => d.id !== docId) }));
  },

  searchWiki: async (orgId, query) => {
    if (!query.trim()) {
      set({ searchResults: [], searchLoading: false });
      return;
    }
    set({ searchLoading: true });
    try {
      const results = await searchWikiPages(orgId, query);
      set({ searchResults: results, searchLoading: false });
    } catch (err) {
      console.error('Error searching wiki:', err);
      set({ searchLoading: false });
    }
  },

  clearSearch: () => set({ searchResults: [], searchLoading: false }),
}));
